// extracted by mini-css-extract-plugin
module.exports = {"container":"SingleImageText__container","primaryLink":"SingleImageText__primaryLink","figure":"SingleImageText__figure","image":"SingleImageText__image"};